/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_IntroInputs */

const en_gc_search_guides_what_is_gridcraft_intro = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft is an open-source spreadsheet application built by ArtCraft in Rust. If you searched for “grid craft” or “gridcraft spreadsheet,” this is the Excel-style app for workbooks, formulas and charts. This site, gridcraft.me, is an independent guide and hosts the official v0.7.0 browser build.`)
};

const zh_gc_search_guides_what_is_gridcraft_intro = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 是 ArtCraft 团队使用 Rust 开发的开源电子表格应用。如果你搜索的是“grid craft”或“gridcraft spreadsheet”，这里介绍的是用于工作簿、公式和图表的类 Excel 应用。gridcraft.me 是独立指南网站，并托管官方 v0.7.0 浏览器构建。`)
};

/**
* | output |
* | --- |
* | "GridCraft is an open-source spreadsheet application built by ArtCraft in Rust. If you searched for “grid craft” or “gridcraft spreadsheet,” this is the Excel..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_intro = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_intro(inputs)
	return zh_gc_search_guides_what_is_gridcraft_intro(inputs)
});
export { gc_search_guides_what_is_gridcraft_intro as "gc.search_guides.what_is_gridcraft.intro" }